// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { priceStyles } from "@werner/Overrides/Widgets/ProductDetails/ProductDetailsPrice";
import { css } from "styled-components";

const sharedTextStyles: TypographyPresentationProps = {
    size: 22,
    weight: 500,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};

priceStyles.productPrice = {
    wrapper: {
        className: "product-details-price",
        css: css`
            align-items: center;
        `,
    },
    price: {
        priceText: { ...sharedTextStyles },
        unitOfMeasureText: { ...sharedTextStyles },
        unitOfMeasure: {
            unitOfMeasureText: {
                ...sharedTextStyles,
            },
        },
    },
};

priceStyles.selectForPricingStyling = {
    size: 22,
    weight: 500,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        text-align: center;
        display: block;
    `,
};
